module.exports = __webpack_public_path__ + "img/404-animated.8522ebd6.gif";